<div class="box_default box_white add_rule">
  <div *ngIf="status==STATUS_DONE else rulesmainloading"  class="box_main">
    <form [formGroup]="form">
      <div class="box_item">
        <label class="box-label">NAME OF THE RULE</label>
        <input type="text" placeholder="Start by giving the rule a name that is clear and descriptive" formControlName="name" />
        <div class="event-select">
            <!-- TODO update options and optionSelected with values from store -->
          <settings-rules-rule-form-helper-select
            [placeholder]="'Select an event/action'"
            [label]="'Event/action'"
            [options]="availableEvents"
            [optionSelected]="rule.key"
            (actionSelect)="selectEvent($event)"
          ></settings-rules-rule-form-helper-select>
        </div>
      </div>
      <div class="rule-specifications">
        <ng-container *ngIf="rule.key!=''" >
          <settings-rules-rule-form-conditions-main
              [form]="form"
          ></settings-rules-rule-form-conditions-main>
          <!-- place here new component for rule specifications where inside the conditions 
            and the variables will be loaded in html -->
        </ng-container>
        <ng-container *ngIf="rule.key!=''" >
          <settings-rules-rule-form-actions-main
          ></settings-rules-rule-form-actions-main>
          <!-- place here new component for rule specifications where inside the actions 
            and the variables will be loaded in html -->
        </ng-container>
        <div class="box_fieldset">
                <core-helpers-forms-button-white [disabled]="buttonDisabled || errorLowerCase || !ruleReady" [text]="saveBtntext" (click)= "onSubmit()"></core-helpers-forms-button-white>
                <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
        </div>
      </div>
    </form>
  </div>
  <!-- oct-2023 <diego@twonas.com>: maybe we need a ngSwitch - ngSwitchCase instead of if else -->
  <ng-template #rulesmainloading>
    <div class="loader">
      <div class="dimmed" >
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
        </div>
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
